module.exports = __webpack_public_path__ + "static/media/is.cff140f4.svg";